import type { FC, ReactNode } from 'react'
import type { Testimonial } from '@/types'

import { ArrowRight } from 'lucide-react'
import { ButtonLink } from '@/components/generals/button'
import { SectionHeading } from '@/components/generals/section-heading'
import { TestimonialCard } from '@/components/generals/testimonial-card'

interface TestimonialsSectionProps {
    testimonials: Testimonial[]
}

export const TestimonialsSection: FC<TestimonialsSectionProps> = ({ testimonials }): ReactNode => {
    if (testimonials.length === 0) return null

    return (
        <section id='testimonials' aria-labelledby='testimonials-title' className='bg-sand py-24 lg:py-32'>
            <div className='mx-auto max-w-7xl px-6'>
                <div className='flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between'>
                    <SectionHeading
                        eyebrow='Kind words'
                        titleId='testimonials-title'
                        title={(
                            <>
                                What our
                                {' '}
                                <em className='text-crimson'>clients</em>
                                {' '}
                                say
                            </>
                        )}
                        description='Couples, families, brands and stadium operators who trusted us with their big day.'
                    />

                    <ButtonLink href='/clients#reviews' variant='outline-dark' className='self-start lg:self-auto'>
                        Read all reviews
                        <ArrowRight className='size-4' aria-hidden='true' />
                    </ButtonLink>
                </div>

                <div className='mt-14 columns-1 gap-5 md:columns-2 lg:columns-3'>
                    {testimonials.map((testimonial) => (
                        <TestimonialCard key={testimonial.id} testimonial={testimonial} className='mb-5 break-inside-avoid' />
                    ))}
                </div>
            </div>
        </section>
    )
}
